import { createContext, useContext } from 'react';

export type MemberBeneficiary = {
  name: string;
  user_id: string;
  department: string;
  amount: string;
};

export type GiftMembersContextType = {
  beneficiaries: MemberBeneficiary[];
  setBeneficiaries: (items: MemberBeneficiary[]) => void;
  totalSum: number;
  setTotalSum: (item: number) => void;
};

export const GiftMembersContext = createContext({} as GiftMembersContextType);

const useGiftMembersContext = () => {
  const context = useContext(GiftMembersContext);
  return context;
};

export default useGiftMembersContext;
